import { render, staticRenderFns } from "./dubbingItem.vue?vue&type=template&id=2068c5ac&scoped=true"
import script from "./dubbingItem.vue?vue&type=script&lang=js"
export * from "./dubbingItem.vue?vue&type=script&lang=js"
import style0 from "./dubbingItem.vue?vue&type=style&index=0&id=2068c5ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2068c5ac",
  null
  
)

export default component.exports